<app-auth-layout #authLayout [companyLogo]="companyLogo()">
  <form
    class="form-container"
    [class.fade]="isTransitioning"
    [formGroup]="loginForm"
    (ngSubmit)="step() === steps.Email ? submitEmail() : null"
  >
    @if (step() === steps.Email) {
      <div class="title-container"
        [class.code]="emailControl?.invalid && emailControl?.touched && emailControl?.value || emailValidationErrorSignal()"
      >
        <h1 class="title">{{ 'WebApp.v1.Auth.Login.Title' | translate }}</h1>
  
        <div class="why">
          <div class="read-why" (click)="scrollToWhy()">{{ 'WebApp.v1.Auth.Login.Read.Why' | translate }}</div>
          <span class="white-slash">/</span>
          <div class="play-why" (click)="showHowdyVideo()"><i class="fa-solid fa-play"></i></div>
        </div>
      </div>

      @if (emailControl?.invalid && emailControl?.touched && emailControl?.value) {
        <div class="error">{{ 'WebApp.v1.Auth.Login.InvalidEmailFormat' | translate }}</div>
      } @else if (emailValidationErrorSignal() && emailControl?.value) {
        <div class="error">{{ emailValidationErrorSignal()! | translate }}</div>
      }

      <input
        class="email"
        type="email"
        formControlName="email"
        placeholder="Email"
        autocomplete="email"
      />

      <app-button class="button" [label]="'WebApp.v1.Shared.Buttons.Next' | translate"></app-button>

      <div class="actions">
        <div class="remember-me" (click)="toggleRememberMe()">
          <span class="checkbox-checkmark" [class.checked]="rememberMeControl?.value">
            <i class="fa-solid fa-check"></i>
          </span>
          <label class="persist-login">{{ 'WebApp.v1.Auth.Login.RememberMe' | translate }}</label>
        </div>
        <div class="forgot-code" (click)="goToNextStep(steps.ForgotCode)">{{ 'WebApp.v1.Auth.Login.ForgotCode' | translate }}</div>
      </div>
    }

    @if (step() === steps.SsoLinking) {
      <div class="title-container">
        <h1 class="title">{{ 'WebApp.v1.Auth.Login.LinkingAccount.Title' | translate }}</h1>
        <p class="sub-title">{{ 'WebApp.v1.Auth.Login.LinkingAccount.Security.Text' | translate: { companyName: companyName() } }}</p>
        <p class="sub-title margin">{{ 'WebApp.v1.Auth.Login.LinkingAccount.Continue.Text' | translate: { companyName: companyName() } }}</p>
      </div>

      <app-button class="button" [label]="'WebApp.v1.Shared.Buttons.Continue' | translate" (click)="continueToSsoPage()"></app-button>
    }

    @if (step() === steps.Pin) {
      <div class="title-container" [class.code]="pinValidationErrorSignal()">
        <h1 class="title">{{ 'WebApp.v1.Auth.Login.WelcomeBack' | translate }} {{ userName }}</h1>
        <p class="sub-title">{{ 'WebApp.v1.Auth.Login.EnterPin' | translate }}</p>
      </div>

      @if (pinValidationErrorSignal()) {
        <div class="error">{{ pinValidationErrorSignal()! | translate }}</div>
      }

      @if (showLongPassword) {
        <input
          class="email"
          type="password"
          formControlName="password"
          placeholder="Password"
          autocomplete="current-password"
        />

        <app-button class="button" [label]="'WebApp.v1.Shared.Buttons.Login' | translate" (click)="submitPassword()"></app-button>
      } @else {
        <app-pin-code class="pin-code" (pinChanged)="submitPin($event)"></app-pin-code>
      }

      <div class="actions">
        <div class="remember-me" (click)="goToEmail()">
          <i class="fa-solid fa-chevron-left"></i>
          {{ 'WebApp.v1.Auth.Login.NotYou' | translate }}
        </div>
        <div class="forgot-code" (click)="goToNextStep(steps.ForgotCode);">{{ 'WebApp.v1.Auth.Login.ForgotCode' | translate }}</div>
      </div>
    }
  </form>

  @if (step() === 'forgot-code') {
    <form [formGroup]="forgotCodeForm" (ngSubmit)="submitForgotCode()" class="form-container">
      <div class="title-container" [class.code]="forgotCodeForm.get('email')?.invalid && forgotCodeForm.get('email')?.touched">
        @if (!forgotCodeEmailRequested()) {
          <h1 class="title">{{ 'WebApp.v1.Auth.ForgotCode.ResetPinCode' | translate }}</h1>
          <p class="sub-title">{{ 'WebApp.v1.Auth.ForgotCode.InsertEmail' | translate }}</p>
        } @else {
          <h1 class="title">{{ 'WebApp.v1.Auth.ForgotCode.InstructionsSent' | translate }}</h1>
          <p class="sub-title">{{ 'WebApp.v1.Auth.ForgotCode.CheckEmail' | translate }}</p>
        }
      </div>

      @if (forgotCodeForm.get('email')?.invalid && forgotCodeForm.get('email')?.touched) {
        <div class="error">{{ 'WebApp.v1.Auth.Login.InvalidEmailFormat' | translate }}</div>
      }

      @if (forgotCodeEmailValidationErrorSignal()) {
        <div class="error">{{ forgotCodeEmailValidationErrorSignal()! }}</div>
      }

      <input
        class="email"
        type="email"
        formControlName="email"
        placeholder="Email"
        autocomplete="email"
      />

      @if (!forgotCodeEmailRequested()) {
        <app-button class="button" [label]="'WebApp.v1.Shared.Buttons.Next' | translate"></app-button>

        <div class="actions">
          <div class="forgot-code back" (click)="goToNextStep(steps.Email)">
            <i class="fa-solid fa-chevron-left"></i>
            {{ 'WebApp.v1.Shared.Buttons.Back' | translate }}
          </div>
        </div>
      } @else {
        <i class="fa-solid fa-check big green"></i>
      }
    </form>
  }
</app-auth-layout>
